import React from 'react';
import PropTypes from 'prop-types';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { useMediaQuery } from 'react-responsive';

import ImageTextBlock from '@components/ImageTextBlock';
import TextBlock from '@components/TextBlock';

import './StaticPhoneList.scss';

const MQ_MOBILE_MAX_WIDTH = 767;

const StaticPhoneList = ({ imageList }) => {
  const isMobile = useMediaQuery({ maxWidth: MQ_MOBILE_MAX_WIDTH });

  return (
    <div className="static-phone-list">
      <div className="static-phone-list__title">
        <TextBlock
          title={trans('Lister.landing.page-homecheckers.header')}
          content={trans('Lister.landing.page-homecheckers.body')}
          alignTo="center"
          titleSize="big"
          contentSize="medium"
          style={{ maxWidth: '700px', margin: 'auto' }}
        />
      </div>
      <div className="static-phone-list__container">
        {imageList.map((item, index) => {
          let alignPosition;
          if (isMobile) {
            alignPosition = 'center';
          } else if (index % 2 === 0) {
            alignPosition = 'left';
          } else {
            alignPosition = 'right';
          }
          return (
            <div key={item.imageName} className="static-phone-list__feature">
              <ImageTextBlock
                title={item.title}
                imageSrc={getResourcePath(
                  `/images/phone-scroller/static-media-list/${item.imageName}${
                    isMobile ? '-mobile' : ''
                  }.jpg`
                )}
                content={item.content}
                imagePosition={alignPosition}
                imageDescription={item.imageName}
                imageStyle={{ maxWidth: '710px', width: '100%' }}
                alignTo={alignPosition}
                titleTag="h3"
                titleSize="medium"
                contentSize="medium"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

StaticPhoneList.propTypes = {
  imageList: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default StaticPhoneList;
